import { useElementsMutationObserver } from 'react-dx'

import { dataTrackViewElementName } from './hooks/track-view'

import type { TrackEventElement } from './hooks/create-hooks'

import { trackEmitter } from '@/hooks/analyticsData/helpers/trackEmitter'


import { useRef } from 'react';
/**
 * 声明式埋点管理器：
 * - data-track-view-ele: 元素进入可视区域（80%）时自动上报
 */
export default function TrackEventManager() {
  const intersectionObserverRef = useRef<IntersectionObserver | null>(null)

  useElementsMutationObserver<HTMLElement>(`[${dataTrackViewElementName}]`, {
    onCreate: (element) => {
      const trackElement = element as TrackEventElement
      const trackEvent =
        '$$getTrackEvent' in trackElement
          ? trackElement.$$getTrackEvent?.()
          : null

      if (!trackEvent) {
        return
      }

      if (!intersectionObserverRef.current) {
        intersectionObserverRef.current = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const el = entry.target as HTMLElement
                const evt =
                  '$$getTrackEvent' in el ? el.$$getTrackEvent() : null
                if (evt) {
                  trackEmitter.emit('track-event', evt)
                }
                observer.unobserve(el)
              }
            })
          },
          { threshold: 0.8 },
        )
      }

      trackElement.$$observeTrackEvent = () => {
        intersectionObserverRef.current?.observe(trackElement)
      }
      trackElement.$$observeTrackEvent()
    },
  })

  return null
}
